// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"545": "vendors","59": "katex","615": "quill","677": "vidstack",}[chunkId] || chunkId) + "." + {"198": "c1391ab9","236": "dbd92f3f","316": "e3c7d7c6","527": "f051a9c8","545": "51d6b81f","59": "04222f87","615": "657bc377","62": "bb467771","653": "e1f21f8e","677": "2d0f523c","688": "474a4cbe",}[chunkId] + ".js"
}